import type { RatingResult } from '@core-api/presentation/types/response';
import { useFetchRatingGridResults } from '@mentimeter/presentation-data-hooks/fetch-rating-grid-results';

interface UseRatingGridResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useRatingGridResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseRatingGridResultsParams): {
  results: RatingResult[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useFetchRatingGridResults({
    adminKey,
    interactiveContentId,
    shouldFetchResults,
    sessionId,
  });

  return {
    results: data?.results ?? [],
    isLoading,
  };
};
